import React from "react";
import Modal from "../../common/modal";
import TransactionDetails from "./transactionDetail/TransactionDetails";
import CaseInitiation from "./transactionDetail/CaseInitiation";

class TransactionDetailsModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formState: {
        transactionDetails: true,
        caseCreation: false
      }
    };
    this.startCaseCreation = this.startCaseCreation.bind(this);
    this.cancelCaseCreation = this.cancelCaseCreation.bind(this);
  }

  startCaseCreation() {
    this.setState({
      formState: {
        transactionDetails: false,
        caseCreation: true
      }
    });
  }

  cancelCaseCreation() {
    this.setState({
      formState: {
        transactionDetails: true,
        caseCreation: false
      }
    });
  }

  render() {
    const { transaction, isOpen, onRequestClose } = this.props;
    const { formState } = this.state;
    return (
      <Modal
        title={`Transaction Reference: ${transaction.transactionReference}`}
        isOpen={isOpen}
        onRequestClose={e => {
          if (formState.caseCreation) {
            if (window.confirm("Are you sure you want to exit?"))
              onRequestClose(e);
          } else {
            onRequestClose(e);
          }
        }}
      >
        <hr />
        {formState.transactionDetails && (
          <TransactionDetails
            transactionDetails={transaction}
            startCaseCreation={this.startCaseCreation}
          />
        )}

        {formState.caseCreation && (
          <CaseInitiation
            transactionDetails={transaction}
            cancelCaseCreation={this.cancelCaseCreation}
            closeModal={onRequestClose}
          />
        )}
      </Modal>
    );
  }
}

export default TransactionDetailsModal;



// WEBPACK FOOTER //
// ./src/components/discover/newCase/TransactionDetailsModal.js